import script from "./FederacionAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./FederacionAdminView.vue?vue&type=script&setup=true&lang=js"

import "./FederacionAdminView.vue?vue&type=style&index=0&id=0180db70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0180db70"]])

export default __exports__